import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Const from 'constants';
import {showPopup} from 'helpers/modal';

class PlayerLock extends Component {
    onCheck(isLocked) {
        const {playerId, playersLock, mode = Const.FLEX_MODE} = this.props;

        if (isLocked && playersLock.isLockedAnywhere(playerId)) {
            this.props.dispatch(showPopup('This player has already locked on other position.'));
            return;
        }

        const items = {
            [mode]: {
                [playerId]: isLocked,
            },
        };

        this.props.dispatch(Action.set('LockedPlayers', items));
    }

    render() {
        const {playerId, playersLock, mode = Const.FLEX_MODE} = this.props;
        let {className = ''} = this.props;

        const isLocked = playersLock.isLocked(playerId, mode);
        if (isLocked) {
            className += ' active';
        }

        return (
            <button
                type="button"
                className={className}
                onClick={() => ::this.onCheck(!isLocked)}
                title={isLocked ? 'Lock enabled' : 'Lock disabled'}
                data-testid="lock-button"
            >
                {isLocked ? 'Lock enabled' : 'Lock disabled'}
            </button>
        );
    }
}

function mapStatesToProps(state) {
    const {playersLock} = state;
    return {
        playersLock,
    };
}

export default connect(mapStatesToProps)(PlayerLock);
